import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  FormCheckbox,
  FormCustomField,
  FormEditor,
  FormLocalDateField,
  FormNumberField,
  FormPanel,
  FormSelect,
  FormTextField,
  TextField,
  useFormSelector,
} from '@eas/common-web';
import { useResearchQueryType } from './research-query-api';
import { noop } from 'lodash';
import { ResearchQuery } from '@models';

export function Fields() {
  const researchQueryTypes = useResearchQueryType();
  /*   const labelMapper = useMemo(
    () => localizedAutocompleteLabelMapper(language),
    [language]
  ); */ const { duration } = useFormSelector((data: ResearchQuery) => ({
    duration: data.duration,
  }));

  return (
    <FormPanel
      label={
        <FormattedMessage
          id="TAPIS__RESEARCH_QUERIES__DETAIL__PANEL_TITLE"
          defaultMessage="Základní informace"
        />
      }
    >
      <FormTextField
        name="researcher.username"
        label={
          <FormattedMessage
            id="TAPIS__RESEARCH_QUERIES__DETAIL__FIELD_LABEL__RESEARCHER"
            defaultMessage="Uživatel"
          />
        }
      />
      <FormTextField
        name="ipAddress"
        label={
          <FormattedMessage
            id="TAPIS__RESEARCH_QUERIES__DETAIL__FIELD_LABEL__IP_ADDRESS"
            defaultMessage="IP Adresa"
          />
        }
      />
      <FormSelect
        name="type"
        label={
          <FormattedMessage
            id="TAPIS__RESEARCH_QUERIES__DETAIL__FIELD_LABEL__TYPE"
            defaultMessage="Typ dotazu"
          />
        }
        source={researchQueryTypes}
        valueIsId={true}
      />
      <FormLocalDateField
        name="executed"
        label={
          <FormattedMessage
            id="TAPIS__RESEARCH_QUERIES__DETAIL__FIELD_LABEL__EXECUTED"
            defaultMessage="Vykonáno"
          />
        }
      />
      <FormCustomField
        label={
          <FormattedMessage
            id="TAPIS__RESEARCH_QUERIES__DETAIL__FIELD_LABEL__DURATION"
            defaultMessage="Doba trvání"
          />
        }
      >
        <TextField onChange={noop} value={duration + ' ms'} disabled={true} />
      </FormCustomField>

      <FormCheckbox
        name="success"
        label={
          <FormattedMessage
            id="TAPIS__RESEARCH_QUERIES__DETAIL__FIELD_LABEL__SUCCESS"
            defaultMessage="Úspěšné"
          />
        }
      />
      <FormNumberField
        name="resultsCount"
        label={
          <FormattedMessage
            id="TAPIS__RESEARCH_QUERIES__DETAIL__FIELD_LABEL__RESULTS_COUNT"
            defaultMessage="Počet výsledků celkem"
          />
        }
      />
      <FormNumberField
        name="page"
        label={
          <FormattedMessage
            id="TAPIS__RESEARCH_QUERIES__DETAIL__FIELD_LABEL__PAGE"
            defaultMessage="Stránka"
          />
        }
      />
      <FormNumberField
        name="pageSize"
        label={
          <FormattedMessage
            id="TAPIS__RESEARCH_QUERIES__DETAIL__FIELD_LABEL__PAGE_SIZE"
            defaultMessage="Počet výsledů na stránce"
          />
        }
      />
      <FormEditor
        name="query"
        label={
          <FormattedMessage
            id="TAPIS__RESEARCH_QUERIES__DETAIL__FIELD_LABEL__QUERY"
            defaultMessage="Dotaz"
          />
        }
      />
    </FormPanel>
  );
}
